module.exports = __webpack_public_path__ + "static/img/no_result.6150b50.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/状态图标/no_result.png
// module id = r7Zi
// module chunks = 33